import { createContext, useContext } from 'react'
import { ProgressBarSteps } from 'src/Libs/shop/types'

interface NormalSystemConfigurationContextProps {
  activePage: number
  setActivePage: React.Dispatch<React.SetStateAction<number>>
  handleProgress: (progress: ProgressBarSteps) => void
  allowContinueMain: boolean
  setAllowContinueMain: React.Dispatch<React.SetStateAction<boolean>>
}

export const NormalSystemConfigurationContext = createContext<NormalSystemConfigurationContextProps | undefined>(undefined)

export const useNormalSystemConfigurationContext = (): NormalSystemConfigurationContextProps => {
  const context = useContext(NormalSystemConfigurationContext)

  if (!context) {
    throw new Error('useNormalSystemConfigurationContext must be used within a NormalSystemConfigurationProvider')
  }

  return context
}
